/**
 * Supplier Performance page — the same dashboard the Dashboard's Supplier
 * Performance tab shows, with its own heading, reachable from the side menu.
 */
import SupplierPerformanceDashboard from './supplier-performance/SupplierPerformanceDashboard';

export default function SupplierPerformance() {
  return <SupplierPerformanceDashboard />;
}
